export default Object.freeze({
  CrossSell: 'CrossSell',
  DealProduct: 'DealProduct',
  NotSet: 'NotSet',
})
